import React from "react";
import "./DownItem.css";

const DownloadCard = ({
  icon,
  title,
  type,
  backgroundColor,
  onClick,
  style,
}) => {
  const isDark = type === "dark";

  return (
    <div
      className={`download-card-mobile ${isDark ? "dark" : ""}`}
      style={{ backgroundColor, ...style }}
      onClick={onClick}
    >
      <img src={icon} alt={title} />
      <p className="subTitle">{title}</p>
    </div>
  );
};

export default DownloadCard;
